/**
 * Before & After carousel — prev/next, snap scroll, synced active card
 */
(function () {
  'use strict';

  function initSection(section) {
    const viewport = section.querySelector('[data-ba-carousel]');
    const track = section.querySelector('.cb-ba-carousel__track');
    const prevBtn = section.querySelector('[data-ba-prev]');
    const nextBtn = section.querySelector('[data-ba-next]');
    if (!viewport || !track) return;

    const cards = Array.from(track.querySelectorAll('.cb-ba-card'));
    const nav = section.querySelector('[data-ba-nav]');
    if (!cards.length) return;

    const syncNavHeight = () => {
      const media = cards[0]?.querySelector('.cb-ba-card__media');
      if (nav && media) nav.style.height = `${media.offsetHeight}px`;
    };

    let activeIndex = 0;
    let scrollEndTimer = null;

    const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

    const nearestIndex = () => {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(cardCenter - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    };

    const scrollLeftForCard = (card) => {
      const target = card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2;
      return Math.min(Math.max(0, target), maxScroll());
    };

    const updateButtons = () => {
      if (window.Gwong?.utils?.updateScrollNav) {
        window.Gwong.utils.updateScrollNav(viewport, prevBtn, nextBtn);
        return;
      }
      const atStart = viewport.scrollLeft <= 2;
      const atEnd = viewport.scrollLeft >= maxScroll() - 2;
      const noScroll = maxScroll() <= 2;
      if (prevBtn) prevBtn.hidden = noScroll || atStart;
      if (nextBtn) nextBtn.hidden = noScroll || atEnd;
    };

    const syncActive = () => {
      activeIndex = nearestIndex();
      updateButtons();
    };

    const scrollToIndex = (index, smooth) => {
      const i = Math.max(0, Math.min(index, cards.length - 1));
      activeIndex = i;
      const card = cards[i];
      const left = scrollLeftForCard(card);
      const behavior = smooth ? 'smooth' : 'auto';

      viewport.style.scrollSnapType = 'none';
      viewport.scrollTo({ left, behavior });

      window.clearTimeout(scrollEndTimer);
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        window.clearTimeout(scrollEndTimer);
        viewport.style.scrollSnapType = '';
        syncActive();
      };

      if (smooth) {
        scrollEndTimer = window.setTimeout(finish, 500);
        if ('onscrollend' in viewport) {
          viewport.addEventListener('scrollend', finish, { once: true });
        }
      } else {
        finish();
      }
    };

    const step = (dir) => {
      syncActive();
      scrollToIndex(activeIndex + dir, true);
    };

    prevBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      step(-1);
    });

    nextBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      step(1);
    });

    let scrollTicking = false;
    viewport.addEventListener(
      'scroll',
      () => {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(() => {
          syncActive();
          scrollTicking = false;
        });
      },
      { passive: true }
    );

    const onResize = () => {
      syncNavHeight();
      scrollToIndex(nearestIndex(), false);
    };
    window.addEventListener(
      'resize',
      window.Gwong?.utils?.debounce ? window.Gwong.utils.debounce(onResize, 150) : onResize
    );

    track.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => {
        syncNavHeight();
        scrollToIndex(activeIndex, false);
      }, { once: true });
    });

    requestAnimationFrame(() => {
      scrollToIndex(0, false);
      syncNavHeight();
    });

    if (window.location.hash === '#results') {
      history.replaceState(null, '', `${window.location.pathname}${window.location.search}#before-after`);
    }
  }

  function boot() {
    document.querySelectorAll('.cb-ba-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
